import {ChangeDetectionStrategy, Component, Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, Route} from '@angular/router';

@Component({
    template: '',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ExternalRouteComponent {}

@Injectable()
export class ExternalLinkResolver implements Resolve<any> {
	resolve(route: ActivatedRouteSnapshot): any {
		window.location.href = route.data['targetUri'];
		return true;
	}
}

export class ExternalRoute implements Route {
	data: {
		targetUri: string;
	};
	path: string;
	pathMatch: 'prefix' | 'full' = 'full';
	resolve = { link: ExternalLinkResolver };
	component = ExternalRouteComponent;

	constructor(path: string, targetUri: string) {
		this.path = path;
		this.data = { targetUri };
	}
}
